module.exports = __webpack_public_path__ + "img/Roza-LwtBarzi.87362bb4.jpg";